import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';
import moment from 'moment';
import { enhance } from './enhance';
import Popup from '../../../common/Popup';
import styles from './index.styl';
import {
  CHART_FILTERS_TYPE,
  DATA_SOURCE_TYPE,
  HISTORIC_MONTHS_CALENDAR_TYPE,
} from '../../constants';
import { useAverageData } from '../useAverageData';
import DataHistoricList from '../../DataHistoricList';
import { useSafeDataSourceTitle } from '../../../common/Charts/hooks';

const { CCD } = DATA_SOURCE_TYPE;
const { DAY } = CHART_FILTERS_TYPE;

function SinglePointValueModal({
  openedSinglePointValueModal,
  close,
  dataType,
  month,
  entity,
  value,
  metricSettings: { isWeightInKg },
  intl: { formatMessage },
}) {
  const adaptMainTitle = formatMessage({
    id: `patient.healthboard.titleHistoric.${dataType}`,
  }).substring(4);
  const { getSafeDataSourceTitle } = useSafeDataSourceTitle();

  const sourceTypeTitle = getSafeDataSourceTitle(CCD, formatMessage);
  const safeDateTitle = `${formatMessage({
    id: 'patient.healthboard.average',
  })} ${month}`;

  const data = {
    averageOrTotal: { value, showAverageLine: false, dateForSingleMode: '' },
  };

  const { formatValue, metric } = useAverageData(
    formatMessage,
    data,
    dataType,
    DAY.type,
    true,
    isWeightInKg,
  );

  const matchedDataForMonth = useMemo(
    () =>
      [...entity]
        .filter(item =>
          moment(month, 'MMMM, YYYY').isSame(item.measuredAt, 'month'),
        )
        .reverse(),
    [entity, month],
  );

  return (
    <Popup
      title={adaptMainTitle}
      mobileFullScreen={false}
      onClose={close}
      opened={openedSinglePointValueModal}
      strictClose
      overflowVisible
      withoutAdaptive
    >
      <div className={styles.root}>
        <div className={styles.singleMonthRoot}>
          <div className={styles.valueWrapper}>
            <div className={styles.value}>{formatValue || ''}</div>
            <div className={styles.metric}>{metric}</div>
          </div>
          <div className={styles.rightSideWrapper}>
            <div className={styles.date}>{safeDateTitle}</div>
            <div className={styles.dataSourceTitle}>{sourceTypeTitle}</div>
          </div>
        </div>
        <div className={styles.dataHistoricList}>
          <DataHistoricList
            formatMessage={formatMessage}
            type={dataType}
            data={matchedDataForMonth}
            isWeightInKg={isWeightInKg}
            allValuesForOneDay
            calendarFormatTime={HISTORIC_MONTHS_CALENDAR_TYPE}
          />
        </div>
      </div>
    </Popup>
  );
}

SinglePointValueModal.propTypes = {
  intl: PropTypes.object,
  close: PropTypes.func,
  openedSinglePointValueModal: PropTypes.bool,
  dataType: PropTypes.string,
  month: PropTypes.string,
  entity: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  metricSettings: PropTypes.object,
};

export default enhance(SinglePointValueModal);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/Chart/SinglePointValueModal/index.jsx